/* GOLDSTEI — Shopify Theme
   Verhalten der Website (Navbar.tsx, Loader.tsx, CartDrawer.tsx,
   ProductModal.tsx) ohne React: Header/Logo-Swap, schräge Preise,
   Warenkorb-Schublade, Produktformular und Bildstreifen. */
(() => {
  const config = window.goldstei || {};
  const routes = config.routes || {};
  const strings = config.strings || {};
  const body = document.body;

  /* ---------- Loader: einmal pro Sitzung (Loader.tsx) ---------- */
  const loader = document.getElementById("goldstei-loader");
  if (loader) {
    let seen = false;
    try {
      seen = sessionStorage.getItem("goldstei-loaded") === "1";
    } catch (e) {}
    if (seen) {
      loader.classList.add("page-loader--skip");
    } else {
      const hide = () =>
        setTimeout(() => {
          loader.classList.add("page-loader--fade");
          try {
            sessionStorage.setItem("goldstei-loaded", "1");
          } catch (e) {}
          setTimeout(() => loader.classList.add("page-loader--skip"), 500);
        }, 600);
      if (document.readyState === "complete") hide();
      else window.addEventListener("load", hide, { once: true });
    }
  }

  /* ---------- Header- und Footer-Höhe als CSS-Variablen ---------- */
  const header = document.getElementById("main-header");
  const footer = document.querySelector("footer.footer-main");
  const setVar = (name, el) => {
    if (el) document.documentElement.style.setProperty(name, `${el.offsetHeight}px`);
  };
  if ("ResizeObserver" in window) {
    const ro = new ResizeObserver(() => {
      setVar("--header-height", header);
      setVar("--footer-height", footer);
    });
    if (header) ro.observe(header);
    if (footer) ro.observe(footer);
  } else {
    setVar("--header-height", header);
    setVar("--footer-height", footer);
  }

  /* ---------- Scroll-Zustand + Logo-Swap (Navbar.tsx) ---------- */
  const hero = document.getElementById("hero");
  const titles = Array.from(document.querySelectorAll("h1.section-title"));
  const checkScroll = () => {
    // "scrolled" = Hero nicht (mehr) im Viewport; Seiten ohne Hero gelten
    // immer als scrolled (Klasse kommt dort schon aus theme.liquid)
    if (hero) body.classList.toggle("scrolled", hero.getBoundingClientRect().bottom <= 0);

    // Aktiver sticky Title: seine Section ragt oben aus dem Viewport
    let active = null;
    titles.forEach((title) => {
      title.classList.remove("section-title--active");
      const rect = title.closest("section")?.getBoundingClientRect();
      if (rect && rect.top <= 0 && rect.bottom > 0) active = title;
    });
    if (active) active.classList.add("section-title--active");
    body.classList.toggle("has-sticky-title", Boolean(active));
  };
  checkScroll();
  window.addEventListener("scroll", checkScroll, { passive: true });

  const logo = header?.querySelector(".logo");
  logo?.addEventListener("mouseenter", () => body.classList.add("logo-hover"));
  logo?.addEventListener("mouseleave", () => body.classList.remove("logo-hover"));

  /* ---------- Schräg gestellte Preise (.rotated, ±5°) ---------- */
  const rotate = (root = document) => {
    root.querySelectorAll(".rotated").forEach((el) => {
      const deg = (Math.random() * 10 - 5).toFixed(2);
      el.style.transform = `rotate(${deg}deg)`;
    });
  };
  rotate();

  /* ---------- Sprachwahl: auf Touch-Geräten tippt man auf den Globus ---------- */
  const langForm = document.getElementById("HeaderLanguageForm");
  langForm?.addEventListener("click", (event) => {
    if (!window.matchMedia("(hover: none)").matches) return;
    if (event.target.closest("button")) return;
    const other = langForm.querySelector("button:not(.lang-toggle--active)");
    other?.click();
  });

  /* ---------- Warenkorb ---------- */
  const drawer = document.getElementById("CartDrawer");
  const cartPage = document.querySelector("[data-cart-page]");

  const openCart = () => {
    if (!drawer) return;
    body.classList.add("cart-open");
    drawer.focus({ preventScroll: true });
  };
  const closeCart = () => body.classList.remove("cart-open");

  const updateBadge = (count) => {
    document.querySelectorAll("[data-cart-count-badge]").forEach((badge) => {
      badge.textContent = count > 99 ? "99+" : String(count);
      badge.hidden = count === 0;
    });
  };

  const renderDrawer = (html) => {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById("CartDrawerContent");
    const current = document.getElementById("CartDrawerContent");
    if (!next || !current) return;
    current.replaceWith(next);
    updateBadge(Number(next.dataset.cartCount || 0));
  };

  const refreshDrawer = async () => {
    const res = await fetch(`${routes.root || "/"}?sections=cart-drawer`);
    const data = await res.json();
    renderDrawer(data["cart-drawer"]);
  };

  const changeLine = async (line, quantity, container) => {
    container?.setAttribute("aria-busy", "true");
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line, quantity, sections: ["cart-drawer"] }),
      });
      if (!res.ok) throw new Error(String(res.status));
      const data = await res.json();
      if (cartPage) {
        window.location.reload();
        return;
      }
      if (data.sections) renderDrawer(data.sections["cart-drawer"]);
      else await refreshDrawer();
    } catch (err) {
      container?.removeAttribute("aria-busy");
      window.alert(strings.cartError);
    }
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-cart-open]");
    if (opener && drawer && !cartPage) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest("[data-cart-close]")) {
      event.preventDefault();
      closeCart();
      return;
    }
    const item = event.target.closest(".cart-item[data-line]");
    if (!item) return;
    const line = Number(item.dataset.line);
    const step = event.target.closest("[data-qty-change]");
    const remove = event.target.closest("[data-qty-remove]");
    if (!step && !remove) return;
    event.preventDefault();
    const qtyEl = item.querySelector(".cart-item-qty-value");
    const current = Number(qtyEl?.value ?? qtyEl?.textContent ?? 1);
    const quantity = remove ? 0 : Math.max(0, current + Number(step.dataset.qtyChange));
    changeLine(line, quantity, item);
  });

  cartPage?.addEventListener("change", (event) => {
    const input = event.target.closest(".cart-item-qty-value");
    const item = event.target.closest(".cart-item[data-line]");
    if (input && item) changeLine(Number(item.dataset.line), Math.max(0, Number(input.value)), item);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && body.classList.contains("cart-open")) closeCart();
  });

  /* ---------- Preis-Format "25.–" (wie snippets/price.liquid) ---------- */
  const formatPrice = (cents) => {
    const value = (cents / 100).toFixed(2);
    const [whole, fraction] = value.split(".");
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return fraction === "00" ? `${grouped}.–` : `${grouped}.${fraction}`;
  };

  /* ---------- Produktformular (ProductModal.tsx) ---------- */
  document.querySelectorAll("[data-product-section]").forEach((section) => {
    const form = section.querySelector("[data-product-form]");
    const jsonEl = section.querySelector("[data-product-json]");
    if (!form || !jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const variantInput = form.querySelector("[data-variant-input]");
    const qtyInput = form.querySelector("[data-qty-input]");
    const priceEl = form.querySelector("[data-price]");
    const addButton = form.querySelector("[data-add-button]");
    const addLabel = form.querySelector("[data-add-label]");
    const errorEl = form.querySelector("[data-form-error]");

    let variant =
      product.variants.find((v) => String(v.id) === variantInput.value) || product.variants[0];
    let justAdded = false;

    const quantity = () => Math.max(1, parseInt(qtyInput.value, 10) || 1);

    const render = () => {
      priceEl.textContent = formatPrice(variant.price * quantity());
      addButton.disabled = !variant.available;
      addLabel.textContent = !variant.available
        ? strings.soldOut
        : justAdded
          ? strings.added
          : strings.add;
      section.querySelectorAll("[data-variant-info]").forEach((el) => {
        el.hidden = el.dataset.variantInfo !== String(variant.id);
      });
    };

    form.addEventListener("change", (event) => {
      if (!event.target.matches("[data-option-position]")) return;
      const selected = product.options.map((_, i) => {
        const checked = form.querySelector(`[data-option-position="${i + 1}"]:checked`);
        return checked ? checked.value : null;
      });
      const match = product.variants.find((v) =>
        v.options.every((value, i) => value === selected[i]),
      );
      if (!match) return;
      variant = match;
      variantInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
      if (variant.featured_media) scrollToMedia(section, variant.featured_media.id);
      render();
    });

    form.querySelectorAll("[data-qty-step]").forEach((btn) => {
      btn.addEventListener("click", () => {
        qtyInput.value = Math.max(1, quantity() + Number(btn.dataset.qtyStep));
        render();
      });
    });
    qtyInput.addEventListener("input", render);

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!variant.available) return;
      errorEl.hidden = true;
      addButton.setAttribute("aria-busy", "true");
      try {
        const res = await fetch(`${routes.cartAdd}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: quantity() }],
            sections: ["cart-drawer"],
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || strings.cartError);
        if (data.sections) renderDrawer(data.sections["cart-drawer"]);
        else await refreshDrawer();
        qtyInput.value = 1;
        justAdded = true;
        render();
        setTimeout(() => {
          justAdded = false;
          render();
        }, 2000);
      } catch (err) {
        errorEl.textContent = err.message || strings.cartError;
        errorEl.hidden = false;
      } finally {
        addButton.removeAttribute("aria-busy");
      }
    });

    render();
  });

  /* ---------- Bildstreifen mit Klickzonen links/rechts ---------- */
  function scrollToMedia(section, mediaId) {
    const slide = section.querySelector(`[data-media-id="${mediaId}"]`);
    const track = slide?.closest("[data-gallery-track]");
    if (slide && track) track.scrollTo({ left: slide.offsetLeft - 16 });
  }

  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const track = gallery.querySelector("[data-gallery-track]");
    const slides = Array.from(track.children);
    if (slides.length < 2) return;

    const currentIndex = () => {
      const left = track.scrollLeft + 20;
      let index = 0;
      slides.forEach((slide, i) => {
        if (slide.offsetLeft <= left) index = i;
      });
      return index;
    };
    const go = (dir) => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      let index = currentIndex() + dir;
      // Endlos wie der Swiper (loop) der Website
      if (dir > 0 && atEnd) index = 0;
      if (index < 0) index = slides.length - 1;
      track.scrollTo({ left: slides[index].offsetLeft - 16 });
    };

    gallery.querySelector("[data-gallery-prev]")?.addEventListener("click", () => go(-1));
    gallery.querySelector("[data-gallery-next]")?.addEventListener("click", () => go(1));
    gallery.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") go(-1);
      if (event.key === "ArrowRight") go(1);
    });
  });

  /* ---------- Schliessen-Kreuz: zurück, falls man aus dem Shop kommt ---------- */
  document.querySelectorAll("[data-back]").forEach((link) => {
    link.addEventListener("click", (event) => {
      try {
        if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
          event.preventDefault();
          window.history.back();
        }
      } catch (e) {}
    });
  });
})();
